import { Slider } from '../../components/Slider';
import { useEditorStore } from '../../store/editorStore';

// White balance + tone: the core Basic panel.
export function BasicPanel() {
  const state = useEditorStore((s) => s.state);
  const set = useEditorStore((s) => s.set);

  return (
    <>
      <p className="hint">White Balance</p>
      <Slider
        label="Temp"
        help="temp"
        value={state.temp}
        min={-100}
        max={100}
        onChange={(v) => set('temp', v)}
      />
      <Slider
        label="Tint"
        help="tint"
        value={state.tint}
        min={-100}
        max={100}
        onChange={(v) => set('tint', v)}
      />

      <p className="hint">Tone</p>
      <Slider
        label="Exposure"
        help="exposure"
        value={state.exposure}
        min={-5}
        max={5}
        step={0.01}
        onChange={(v) => set('exposure', v)}
      />
      <Slider
        label="Contrast"
        help="contrast"
        value={state.contrast}
        min={-100}
        max={100}
        onChange={(v) => set('contrast', v)}
      />
      <Slider
        label="Highlights"
        help="highlights"
        value={state.highlights}
        min={-100}
        max={100}
        onChange={(v) => set('highlights', v)}
      />
      <Slider
        label="Shadows"
        help="shadows"
        value={state.shadows}
        min={-100}
        max={100}
        onChange={(v) => set('shadows', v)}
      />
      <Slider
        label="Whites"
        help="whites"
        value={state.whites}
        min={-100}
        max={100}
        onChange={(v) => set('whites', v)}
      />
      <Slider
        label="Blacks"
        help="blacks"
        value={state.blacks}
        min={-100}
        max={100}
        onChange={(v) => set('blacks', v)}
      />
    </>
  );
}
